import { client } from '../../../../../common-utils/libraries/axios/axios';
import SESSION from '../apiUrls';
import assetsFields from '../../fields/assetsFields';

/**
 * @param responseData response.data object
 * @param responseData.background string
 * @param responseData.backgroundSmall string
 * @param responseData.pathFavicon object
 * @param responseData.pathLogo string
 * @param responseData.title string
 *
 * @param response
 * @returns Mapped data object
 */
function mapResponseData(response) {
    const data = {};
    data[assetsFields.BACKGROUND.key] = response[assetsFields.BACKGROUND.key];
    data[assetsFields.BACKGROUND_SMALL.key] = response[assetsFields.BACKGROUND_SMALL.key];
    data[assetsFields.PATH_FAVICON.key] = response[assetsFields.PATH_FAVICON.key];
    data[assetsFields.PATH_LOGO.key] = response[assetsFields.PATH_LOGO.key];
    data[assetsFields.TITLE.key] = response[assetsFields.TITLE.key];

    return data;
}

const queryGetAssets = (enabled = true) => {
    return {
        queryKey: [SESSION.ASSETS.queryKey],
        queryFn: async () => {
            const response = await client.get(SESSION.ASSETS.url);
            return mapResponseData(response.data);
        },
        staleTime: Infinity,
        enabled: enabled
    };
};

export default queryGetAssets;